export default __webpack_public_path__ + "static/media/2043.c972d1f5.png";